module.exports = __webpack_public_path__ + "img/close.0eeb31fb.svg";